import types from './constant';
import initialState from './initialState';

export default (state = initialState, action) => {
  switch (action.type) {
    case types.AGENTS_GET_LIST_FETCH_REQUEST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          listAgents: true,
        },
      };

    case types.AGENTS_GET_LIST_FETCH_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          listAgents: false,
        },
        api: {
          ...state.api,
          agents: action.payload.agents,
          pagination: action.payload.pagination,
        },
      };

    case types.AGENTS_GET_LIST_FETCH_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          listAgents: false,
        },
      };

    case types.AGENTS_GET_BY_ID_FETCH_REQUEST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          getAgent: true,
        },
      };

    case types.AGENTS_GET_BY_ID_FETCH_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          getAgent: false,
        },
        api: {
          ...state.api,
          currentAgent: action.payload.agent,
        },
      };

    case types.AGENTS_GET_BY_ID_FETCH_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          getAgent: false,
        },
      };

    case types.AGENTS_CREATE_FETCH_REQUEST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          createAgent: true,
        },
      };

    case types.AGENTS_CREATE_FETCH_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          createAgent: false,
        },
        api: {
          ...state.api,
          agents: [action.payload.agent, ...state.api.agents],
        },
      };

    case types.AGENTS_CREATE_FETCH_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          createAgent: false,
        },
      };

    case types.AGENTS_UPDATE_FETCH_REQUEST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          updateAgent: true,
        },
      };

    case types.AGENTS_UPDATE_FETCH_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          updateAgent: false,
        },
        api: {
          ...state.api,
          currentAgent: action.payload.agent,
          agents: state.api.agents.map(agent =>
            agent.id === action.payload.agent.id ? action.payload.agent : agent
          ),
        },
      };

    case types.AGENTS_UPDATE_FETCH_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          updateAgent: false,
        },
      };

    case types.AGENTS_DELETE_FETCH_REQUEST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          deleteAgent: true,
        },
      };

    case types.AGENTS_DELETE_FETCH_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          deleteAgent: false,
        },
        api: {
          ...state.api,
          agents: state.api.agents.filter(agent => agent.id !== action.payload.agentId),
        },
      };

    case types.AGENTS_DELETE_FETCH_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          deleteAgent: false,
        },
      };

    case types.AGENTS_DUPLICATE_FETCH_REQUEST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          duplicateAgent: true,
        },
      };

    case types.AGENTS_DUPLICATE_FETCH_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          duplicateAgent: false,
        },
        api: {
          ...state.api,
          agents: [action.payload.agent, ...state.api.agents],
        },
      };

    case types.AGENTS_DUPLICATE_FETCH_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          duplicateAgent: false,
        },
      };

    case types.AGENTS_UPLOAD_DOCUMENT_FETCH_REQUEST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          uploadDocument: true,
        },
      };

    case types.AGENTS_UPLOAD_DOCUMENT_FETCH_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          uploadDocument: false,
        },
      };

    case types.AGENTS_UPLOAD_DOCUMENT_FETCH_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          uploadDocument: false,
        },
      };

    case types.AGENTS_DELETE_DOCUMENT_FETCH_REQUEST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          deleteDocument: true,
        },
      };

    case types.AGENTS_DELETE_DOCUMENT_FETCH_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          deleteDocument: false,
        },
      };

    case types.AGENTS_DELETE_DOCUMENT_FETCH_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          deleteDocument: false,
        },
      };

    case types.AGENTS_TEST_FETCH_REQUEST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          testAgent: true,
        },
      };

    case types.AGENTS_TEST_FETCH_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          testAgent: false,
        },
      };

    case types.AGENTS_TEST_FETCH_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          testAgent: false,
        },
      };

    case types.AGENTS_SET_SEARCH_FILTER:
      return {
        ...state,
        api: {
          ...state.api,
          filters: {
            ...state.api.filters,
            search: action.payload,
          },
        },
      };

    case types.AGENTS_SET_STATUS_FILTER:
      return {
        ...state,
        api: {
          ...state.api,
          filters: {
            ...state.api.filters,
            status: action.payload,
          },
        },
      };

    case types.AGENTS_SET_PAGINATION:
      return {
        ...state,
        api: {
          ...state.api,
          pagination: {
            ...state.api.pagination,
            ...action.payload,
          },
        },
      };

    default:
      return state;
  }
};

